console.log("tac-badges.js");

(function () {

    function videoCookieRefuseeDansTarteaucitron() {
        document.querySelectorAll(".tarteaucitron-magic-block").forEach(function (el) {
            const parent = el.closest(".video-container");
            if (parent) {
                parent.classList.add("refus__tarte__au__citron");

                const allowBtn = parent.querySelector(".tarteaucitronAllow");

                if (allowBtn && !allowBtn.previousElementSibling?.classList?.contains("tac-span")) {
                    const span = document.createElement("span");
                    span.className = "tac-span";
                    allowBtn.before(span);
                }
            }
        });
    }

    function masquerBlockquoteRefuseInstagram() {
        document.querySelectorAll(".tarteaucitron-magic-block-instagram").forEach(function (el) {
            const prev = el.previousElementSibling;
            if (prev && prev.tagName === "BLOCKQUOTE") {
                prev.style.display = "none";
            }
        });
    }

    function markTarteaucitronReady() {
        document.documentElement.classList.add("tac-ready");
    }

    function runWhenReady() {
        videoCookieRefuseeDansTarteaucitron();
        masquerBlockquoteRefuseInstagram();
        markTarteaucitronReady();
    }

    function waitForStableDOM() {

        let timer = null;

        const observer = new MutationObserver(() => {

            clearTimeout(timer);

            timer = setTimeout(() => {

                // 🔥 on ne teste plus "présence"
                // on considère que si ça ne bouge plus => c'est prêt

                requestAnimationFrame(() => {
                    runWhenReady();
                });

                observer.disconnect();

            }, 250); // 👈 stabilité DOM (clé réelle ici)

        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    window.addEventListener('tac.root_available', function () {
        waitForStableDOM();
    });

})();